import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

export const BASE_URL = "https://api.bizooka.co/api/";

export const success = (msg) =>
  toast.success(msg, {
    hideProgressBar: true,
    autoClose: 1500,
    position: "top-center",
  });

export const constant = {
  DEVICE_TYPE: "web",
  DEVICE_TOKEN: "",
  LOCAL_STORAGE_TOKEN: "foodnauts-token",
  LOCAL_STORAGE_USER: "foodnauts-user",
  LOCAL_STORAGE_ROLE: "foodnauts-role",
  LOCAL_STORAGE_EMAIL_SIGNUP: "signup-email",
  BASE_URL: "http://localhost:5000",
  // BASE_URL: "http://backend.liveurl.com:5000",
  IMAGE_DIR_NAME: "images",
  VIDEO_DIR_NAME: "videos",
  VER: "/api",
  auth: "/auth",
};

export const messageTypes = {
  text: 1,
  image: 2,
  video: 3,
  audio: 4,
  doc: 5,
};

export const apiUrl = {
  // Api Urls Here
};

export const s3Credential = {
  bucketName: "",
  region: "",
  accessKeyId: "",
  secretAccessKey: "",
  s3EndPoint: "",
  fileSize: "",
  dirName: "",
};

export const errorMessages = {
  fileSize: "The file size is too large",
  fileSuccess: "file uploaded successfully",
  fileError: "Error in uploading file",
};
